'use client';

import { ICognitoStorage } from 'amazon-cognito-identity-js';

export class MemoryStorage implements ICognitoStorage {
  private data: Record<string, string>;

  constructor() {
    this.data = {};
  }
  setItem(key: string, value: string): void {
    this.data[key] = value;
  }
  getItem(key: string): string | null {
    return this.data[key] ?? null;
  }
  removeItem(key: string): void {
    delete this.data[key];
  }
  clear(): void {
    this.data = {};
  }
}
